import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_GET_EVALUATION_OUTCOME_REQUEST = `${MODULE_PREFIX}_GET_EVALUATION_OUTCOME_REQUEST`;
export const QUESTIONNAIRE_EVALUATION_GET_EVALUATION_OUTCOME_SUCCESS = `${MODULE_PREFIX}_GET_EVALUATION_OUTCOME_SUCCESS`;
export const questionnaireEvaluationGetOutcomeRequestAction = (requestData) => ({
    type: QUESTIONNAIRE_EVALUATION_GET_EVALUATION_OUTCOME_REQUEST,
    payload: requestData
});
export const questionnaireEvaluationGetOutcomeSuccessAction = (responseData) => ({
    type: QUESTIONNAIRE_EVALUATION_GET_EVALUATION_OUTCOME_SUCCESS,
    payload: responseData
});
//# sourceMappingURL=questionnaireEvaluationGetOutcomeActions.js.map